import { Badge } from '@/components/ui/badge';
import type { TicketListItem } from '@/services/tech-support.service';

type BadgeVariant = React.ComponentProps<typeof Badge>['variant'];

const PRIORITY_CONFIG: Record<TicketListItem['priority'], { label: string; variant: BadgeVariant }> = {
  low:    { label: 'Low',    variant: 'outline' },
  medium: { label: 'Medium', variant: 'secondary' },
  high:   { label: 'High',   variant: 'warning' },
  urgent: { label: 'Urgent', variant: 'destructive' },
};

interface Props {
  priority: TicketListItem['priority'];
}

export function TicketPriorityBadge({ priority }: Props) {
  const cfg = PRIORITY_CONFIG[priority] ?? { label: priority, variant: 'secondary' as BadgeVariant };
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}
